import { type LayoutY } from '#packages/layout';
import type { SlotData } from '../types';

export function findAvailableSlotV3(
  slots: SlotData[],
  _compLayout: LayoutY,
  _dragDirection: 'up' | 'down',
  mousePosition: { pageY: number; pageX: number },
) {
  return slots.reduce(
    (closestSlot, currentSlot) => {
      if (!closestSlot) {
        return currentSlot;
      }

      const currentSlotMiddleY =
        currentSlot.layout.y + currentSlot.layout.height / 2;
      const closestSlotMiddleY =
        closestSlot.layout.y + closestSlot.layout.height / 2;

      if (
        Math.abs(mousePosition.pageY - currentSlotMiddleY) <
        Math.abs(mousePosition.pageY - closestSlotMiddleY)
      ) {
        return currentSlot;
      }
      return closestSlot;
    },
    null as SlotData | null,
  );
}
